module.exports = __webpack_public_path__ + "static/media/ico_citbank_512.8670f178.png";